define(function(require) {
    'use strict';
    var pasUtil = require('util/pas.util');

    // It should be removed with the next Core merge (in Ark)
    pasUtil.setDeviceId = function(deviceId) {
        if (!deviceId) {
            try {
                deviceId = localStorage.getItem('hub2_device_uuid');
            } catch (e) {
                console.error('Local storage is not available');
            }

            if (!deviceId) {
                deviceId = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);

                try {
                    localStorage.setItem('hub2_device_uuid', deviceId);
                } catch (e) {
                    console.error('Local storage is not available');
                }
            }

            console.log('APPLY FIX FOR DEVICE ID: ', deviceId);
        }

        return this._call(function() {
            window.iapiSetDeviceId(encodeURIComponent(deviceId));
        });
    };

    return pasUtil;
});
